import * as React from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

import * as styles from './style.css';
import LayoutComponentsSpinner from "../spinner";

const Logo = require('./icons/logo.svg');

class LayoutComponentsLoaderProcessing extends React.PureComponent {

  static defaultProps = {
    opacity: .8,
    show: false,
    isMemorialTheme: false,
  };

  static propTypes = {
    opacity: PropTypes.number,
    show: PropTypes.bool,
    isMemorialTheme: PropTypes.bool,
  };

  render() {
    const containerStyle = 
      this.props.isMemorialTheme ? 
      { backgroundColor: '#1F2C4E' } : 
      { backgroundColor: `rgba(124,108,229,${this.props.opacity})` };
    return (
      <CSSTransition
        in={this.props.show}
        timeout={400}
        classNames="fade"
        unmountOnExit
        mountOnEnter>
        <div className={styles.modalContainer} style={containerStyle}>
          <div className={styles.inner}>
            <img src={Logo} className={styles.logo} />
            { !this.props.isMemorialTheme && <LayoutComponentsSpinner/> }
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default LayoutComponentsLoaderProcessing;


// WEBPACK FOOTER //
// ./src/app/modules/layout/ui/components/loader-processing/index.jsx